module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./MyDonationView.js"));
	}, "MyDonationView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyDonationView!./src/pages/Shop/Home/Carnival/commonweal/MyDonation/MyDonationView.js
// module id = 953
// module chunks = 431